import StoreProducts from '../StoreProducts';
import StoreSales from '../StoreSales';
import { ComplexRoute } from 'router/components/Routes/Routes';
import SaleOrdersPage from '../SaleOrders';
import InventoryPlacementPage from '../InventoryPlacement';
import Checksums from '../../../Checksums';
import InventoryLocationsPage from '../../../InventoryLocations';
import StoreInventory from '../../../StoreInventory';

export default [
  {
    path: 'products',
    element: StoreProducts,
  },
  {
    path: 'sales',
    element: StoreSales,
  },
  {
    path: 'inventory',
    element: StoreInventory,
  },
  {
    path: 'inventory-locations',
    element: InventoryLocationsPage,
  },
  {
    path: 'inventory-placement',
    element: InventoryPlacementPage,
  },
  {
    path: 'sale-orders',
    element: SaleOrdersPage,
  },
  {
    path: 'validation',
    element: Checksums,
  },
] as Array<ComplexRoute>;
